import React from 'react';
import { GeneratedPrompt } from '../types/prompt';
import { Clock, Star, Copy, Trash2 } from 'lucide-react';

interface PromptHistoryProps {
  prompts: GeneratedPrompt[];
  onToggleFavorite: (id: string) => void;
  onDelete: (id: string) => void;
  onCopy: (prompt: string) => void;
}

const PromptHistory: React.FC<PromptHistoryProps> = ({
  prompts,
  onToggleFavorite,
  onDelete,
  onCopy
}) => {
  if (prompts.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <Clock className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>No prompts in history yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {prompts.map((prompt) => (
        <div
          key={prompt.id}
          className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2">
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                {prompt.platform}
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded">
                {prompt.category}
              </span>
            </div>
            <div className="flex gap-1">
              <button
                onClick={() => onToggleFavorite(prompt.id)}
                className={`p-1 rounded transition-colors ${
                  prompt.isFavorite
                    ? 'text-yellow-500 hover:text-yellow-600'
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                <Star className="w-4 h-4" fill={prompt.isFavorite ? 'currentColor' : 'none'} />
              </button>
              <button
                onClick={() => onCopy(prompt.prompt)}
                className="p-1 text-gray-400 hover:text-gray-600 rounded transition-colors"
              >
                <Copy className="w-4 h-4" />
              </button>
              <button
                onClick={() => onDelete(prompt.id)}
                className="p-1 text-gray-400 hover:text-red-600 rounded transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
          <p className="text-sm text-gray-800 font-mono line-clamp-2">{prompt.prompt}</p>
          <p className="text-xs text-gray-500 mt-2">
            {new Date(prompt.timestamp).toLocaleDateString()} at{' '}
            {new Date(prompt.timestamp).toLocaleTimeString()}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PromptHistory;